import {call, put, select} from "redux-saga/effects";
import api from "../../services/api";
import {Creators as MetasActions} from "../ducks/metas";
import {Creators as ModalActions} from "../ducks/modal";
import {Creators as AlertActions} from "../ducks/alert";
import {Creators as ErrorActions} from "../ducks/error";
import {Creators as SuccessActions} from "../ducks/success";
import {Creators as LoadingActions} from "../ducks/loading";
import {Creators as PageActions} from "../ducks/pages";

export function* getListMetas() {
  try {
    yield put(LoadingActions.setLoading());
    const {page, rowsPerPage, filter} = yield select(state => state.metas);
    const {data} = yield call(
      api.post,
      `/goals-settings/filter?page=${page + 1}&&per_page=${rowsPerPage}`,
      filter
    );
    const {data: metas, total} = data;
    let metasPayload = [];
    metasPayload = metas.map(meta => ({
      id: meta.id,
      name: meta.name,
      first_level: meta.first_level
        .replace("stores", "lojas")
        .replace("regions", "regiões")
        .replace("banks", "bancos")
        .replace("operations", "operações")
        .replace("promoters", "promotores")
        .replace("products", "produtos")
        .replace("gerentes", "gerentes lojas")
        .replace("region_managers", "gerentes regiões")
        .replace("convenets", "convênios"),
      second_level: meta.second_level
        ? meta.second_level
          .replace("stores", "lojas")
          .replace("regions", "regiões")
          .replace("banks", "bancos")
          .replace("operations", "operações")
          .replace("promoters", "promotores")
          .replace("products", "produtos")
          .replace("gerentes", "gerentes lojas")
          .replace("region_managers", "gerentes regiões")
          .replace("convenets", "convênios")
        : "",
      base_calcule:
        meta.base_calcule === 1
          ? "Valor Liberado"
          : meta.base_calcule === 2
          ? "Valor Financiado"
          : meta.base_calcule === 3
            ? "Valor Parela"
            : meta.base_calcule === 4
              ? "Valor Dívida"
              : "Valor Base",
      inactived: meta.inactived
    }));
    const name = "Metas";
    const path = "metas";
    yield put(PageActions.setPage(name, path));
    yield put(MetasActions.getListMetasSuccess(metasPayload, total));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getMetas({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {data} = yield call(api.get, `/goals-settings/${payload.id}`);
    yield put(MetasActions.getMetasSuccess(data));
    const {action} = yield select(state => state.metasStores);

    if (action === "EDIT") {
      yield put(ModalActions.open());
    } else if (action === "DETAIL") {
      const {data} = yield call(
        api.get,
        `/goals-settings/load/${payload.id}`
      );
      yield put(
        MetasActions.getMetasLoaders(
          data.first_level,
          data.second_level
        )
      );
      yield put(ModalActions.open());
    } else {
      const title = "Aviso de exclusão";
      const body = `O cadastro "${data.name}" será excluido do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editMetas({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.put, `/goals-settings/${payload.id}`, payload);
    yield put(MetasActions.getListMetas());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
    yield put(MetasActions.getListMetasSelects());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addMetas({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/goals-settings`, payload);
    yield put(MetasActions.searchMetas({}));
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* addMetasMetas({payload}) {
  try {
    yield call(api.post, `/goals`, payload);
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
    const {refreshMetas} = yield select(state => state.metas);
    yield put(MetasActions.addMetasMetasSuccess((refreshMetas + 1)));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteMetas() {
  try {
    yield put(LoadingActions.setLoading());
    const {id} = yield select(state => state.metas.item);
    yield call(api.delete, `/goals-settings/${id}`);
    yield put(MetasActions.getListMetas());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
    yield put(MetasActions.getListMetasSelects());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchMetas() {
  try {
    yield put(MetasActions.getListMetas());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListMetasSelects() {
  try {
    const {data: metas} = yield call(api.get, `/goals-settings/select`);
    yield put(MetasActions.getListMetasSuccessSelects(metas));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join();
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/metas.js